import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { forkJoin, lastValueFrom, Observable, of, switchMap, tap } from 'rxjs';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { TRANSPORTATION_TYPES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { FlightSearchComponent } from '../../flight-search/flight-search.component';

@Component({
  selector: 'app-transportation',
  templateUrl: './transportation.component.html',
  styleUrls: ['./transportation.component.scss'],
})
export class TransportationComponent implements OnInit {

  @Input() leadId: any;
  @Input() itineraryId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() storeFlightsFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeTrainsFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeBusesFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeCarsFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeFerryFormData: EventEmitter<any> = new EventEmitter();
  @Output() storeCruiseFormData: EventEmitter<any> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();

  @Input() itineraryDetails: any;

  noOfAdults: number = 0;
  noOfChildren: number = 0;
  noOfInfants: number = 0;
  childrenBelowTwo: any = 0;
  childrenAboveTwo: any = 0;

  TRANSPORTATION_TYPES = TRANSPORTATION_TYPES;

  transportationTypes: any[] = [
    { key: TRANSPORTATION_TYPES.FLIGHT, name: "Flight" },
    { key: TRANSPORTATION_TYPES.TRAIN, name: "Train" },
    { key: TRANSPORTATION_TYPES.BUS, name: "Bus" },
    { key: TRANSPORTATION_TYPES.CAR, name: "Car" },
    { key: TRANSPORTATION_TYPES.FERRY, name: "Ferry" },
    { key: TRANSPORTATION_TYPES.CRUISE, name: "Cruise" },
  ]

  @Input() storedFlightsData: any;
  @Input() storedTrainsData: any;
  @Input() storedBusesData: any;
  @Input() storedCarsData: any;
  @Input() storedFerryData: any;
  @Input() storedCruiseData: any;

  allExistingTransportsData: any = [];

  @Input() editInventory: boolean = false;
  @Input() editQuote: boolean = false;

  @Input() serviceBasedSections: any;

  transportationForm!: FormGroup;


  showOnlyCarTransport: boolean = false;
  placesType: string[] = ['airport'];
  vehicleTypeValues = [
    { key: 'sedan', name: 'Sedan' },
    { key: 'suv', name: 'SUV' },
    { key: 'hatchback', name: 'Hatchback' },
    { key: 'van', name: 'Van' },
    { key: 'minivan', name: 'Minivan' },
    { key: 'luxury_car', name: 'Luxury Car' },
  ];

  transferModeValues = [
    { key: 'private', name: 'Private' },
    { key: 'public', name: 'Public' },
    { key: 'self_drive', name: 'Self-Drive' },
    { key: 'bike_rental', name: 'Bike Rental' },
    { key: 'carpool', name: 'Carpool' },
  ];

  vehicleNameValues = [
    { key: "Dzire", name: "Dzire" },
    { key: "WagonR", name: "WagonR" },
    { key: "Ertiga", name: "Ertiga" },
    { key: "Innova", name: "Innova" },
    { key: "Tavera", name: "Tavera" },
    { key: "Sumo", name: "Sumo" }
  ]

  trainClassValues: any = [
    { key: "Sleeper", name: "Sleeper" },
    { key: "First AC", name: "First AC" },
    { key: "Second AC", name: "Second AC" },
    { key: "Third AC", name: "Third AC" },
  ]

  selectedCurrency: any = "";
  currencyLov: any = [];
  @Output() emitCurrencyChange: EventEmitter<string> = new EventEmitter<string>();

  @Output() emitFlightsRemoved: EventEmitter<any> = new EventEmitter<any>();

  flightApiEnabled:boolean = false;

  constructor(
    private fb: FormBuilder,
    private _itineraryService: ItineraryService,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _lovDataService: LovDataService,
    private _modalController: ModalController
  ) { }

  async ngOnInit() {
    // Initilization of the variables
    this.noOfAdults = 0;
    this.noOfChildren = 0;
    this.noOfInfants = 0;
    this.childrenAboveTwo = 0;
    this.childrenBelowTwo = 0;
    if (this.itineraryDetails) {
      this.updateAllTripDetails();
    }
    if (!this.serviceBasedSections.showTransportation && this.serviceBasedSections.showTransfers) {
      this.showOnlyCarTransport = true;
      this.transportationTypes = [
        { key: TRANSPORTATION_TYPES.CAR, name: "Car" }
      ]
      this.placesType = []
    }

    // Initizalization of form
    this.transportationForm = this.fb.group({
      flightSectionNote: [''],
      trainSectionNote: [''],
      busSectionNote: [''],
      carSectionNote: [''],
      ferrySectionNote: [''],
      cruiseSectionNote: [''],
      transportations: this.fb.array([this.createTransportationGroup()])
    });

    this.transportationForm.valueChanges.subscribe(() => {
      this.transportationForm.markAsTouched();
    })

    this.transportationForm.markAsUntouched();
    this.transportationForm.markAsPristine();

    // Patching transportation data if already exists
    if (this.storedFlightsData || this.storedTrainsData || this.storedBusesData || this.storedCarsData || this.storedFerryData || this.storedCruiseData) {
      this.patchTransportationForm(this.createExistingTransportsList());
      if (this.storedFlightsData?.dataInvalid || this.storedTrainsData?.dataInvalid || this.storedBusesData?.dataInvalid || this.storedCarsData?.dataInvalid || this.storedFerryData?.dataInvalid || this.storedCruiseData?.dataInvalid) {
        this.transportationForm.markAllAsTouched();
        this.transportationForm.markAsDirty();
      }
    }

    this.currencyLov = await this._globalService.loadLovData("CurrencyCode");
    let org = await this._globalService.getLoggedInOrgDetails();
    if (org) {      
      this.flightApiEnabled = org?.travelIntegration?.flightIntegration;
    }
  }

  updateAllTripDetails() {
    this.selectedCurrency = this.itineraryDetails?.currencyCode || "";    
    this.noOfAdults = this.itineraryDetails.totalAdults;
    this.noOfChildren = this.itineraryDetails.totalChildrens;
    this.noOfInfants = this.itineraryDetails.totalInfants;
    this.childrenAboveTwo = this.noOfChildren;
    this.childrenBelowTwo = this.noOfInfants;
  }

  get todayNow(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }

  convertToDate(value: any): Date {
    return new Date(value);
  }
  /////////////////////////////////////
  // Funtions related to form functions
  /////////////////////////////////////

  createTransportationGroup(): FormGroup {
    let defaultTypeOfTransport = this.showOnlyCarTransport ? TRANSPORTATION_TYPES.CAR : TRANSPORTATION_TYPES.FLIGHT;
    const group = this.fb.group({
      index: [0],
      typeOfTransport: [defaultTypeOfTransport],
      selectedType: ["Image"],
      transportationName: [""],   
      typeOfFlight: ["Domestic"],
      imageDoc: [null],
      imagePath: [""],
      departure: [""],
      arrival: [""],
      departureDate: [null],
      departureTime: [null],
      arrivalDate: [null],
      arrivalTime: [null],
      class: [""],
      vendorName: [""],
      name: [""],
      mode: [""],
      typeOfCar: [""],
      vehicleSelection: [""],
      numberOfSeats: [0],
      costPerAdult: [""],
      costPerChild: [""],
      costPerInfant: [""],
      totalCost: [{ value: 0, disabled: true }]
    });

    this.updateFieldValidationBasedOnTransport(group);
    group.get('typeOfTransport')?.valueChanges.subscribe(() => {
      this.updateFieldValidationBasedOnTransport(group);
    });
    group.get('selectedType')?.valueChanges.subscribe(() => {
      this.updateFieldValidationBasedOnTransport(group);
    });

    // Updating validation of cost information
    if (!this.serviceBasedSections.showTourPackage && !this.serviceBasedSections.showRouteCraft) {
      this.updateValidationOfCost(group);
    }

    group.get('costPerAdult')?.valueChanges.subscribe(() => {
      this.calculateTotalCost(group);
    });

    group.get('costPerChild')?.valueChanges.subscribe(() => {
      this.calculateTotalCost(group);
    });

    group.get('costPerInfant')?.valueChanges.subscribe(() => {
      this.calculateTotalCost(group);
    });
    return group;
  }

  updateFieldValidationBasedOnTransport(group: any) {
    // First clear all validators
    group.get("imageDoc")?.clearValidators();
    group.get("transportationName")?.clearValidators();
    group.get("departure")?.clearValidators();
    group.get("arrival")?.clearValidators();
    group.get("departureDate")?.clearValidators();
    group.get("departureTime")?.clearValidators();
    group.get("arrivalDate")?.clearValidators();
    group.get("arrivalTime")?.clearValidators();
    group.get("class")?.clearValidators();
    group.get("vendorName")?.clearValidators();
    group.get("name")?.clearValidators();
    group.get("mode")?.clearValidators();
    group.get("typeOfCar")?.clearValidators();
    group.get("vehicleSelection")?.clearValidators();
    group.get("numberOfSeats")?.clearValidators();

    let selectedType = group.get("selectedType")?.value;
    let typeOfTransport = group.get("typeOfTransport")?.value;

    if (selectedType === "Image") {
      group.get("imageDoc")?.setValidators([Validators.required]);
    } else {
      if ([ TRANSPORTATION_TYPES.FLIGHT, TRANSPORTATION_TYPES.TRAIN, TRANSPORTATION_TYPES.BUS, TRANSPORTATION_TYPES.FERRY, TRANSPORTATION_TYPES.CRUISE ].includes(typeOfTransport))  {
        group.get("imageDoc")?.setValidators([]);
        group.get("transportationName")?.setValidators([Validators.required]);
        group.get("departure")?.setValidators([Validators.required]);
        group.get("arrival")?.setValidators([Validators.required]);
        group.get("departureDate")?.setValidators([Validators.required]);
        group.get("departureTime")?.setValidators([Validators.required]);
        group.get("arrivalDate")?.setValidators([Validators.required]);
        group.get("arrivalTime")?.setValidators([Validators.required]);
      } else if (typeOfTransport === TRANSPORTATION_TYPES.CAR) {
        group.get("imageDoc")?.setValidators([]);
        group.get("transportationName")?.setValidators([Validators.required]);
        group.get("departure")?.setValidators([Validators.required]);
        group.get("arrival")?.setValidators([Validators.required]);
        group.get("vendorName")?.setValidators([Validators.required]);
      }
    }

    // updateValueAndValidity for all controls
    group.get("imageDoc")?.updateValueAndValidity();
    group.get("transportationName")?.updateValueAndValidity();
    group.get("departure")?.updateValueAndValidity();
    group.get("arrival")?.updateValueAndValidity();
    group.get("departureDate")?.updateValueAndValidity();
    group.get("departureTime")?.updateValueAndValidity();
    group.get("arrivalDate")?.updateValueAndValidity();
    group.get("arrivalTime")?.updateValueAndValidity();
    group.get("class")?.updateValueAndValidity();
    group.get("vendorName")?.updateValueAndValidity();
    group.get("name")?.updateValueAndValidity();
    group.get("mode")?.updateValueAndValidity();
    group.get("typeOfCar")?.updateValueAndValidity();
    group.get("vehicleSelection")?.updateValueAndValidity();
    group.get("numberOfSeats")?.updateValueAndValidity();

    // Updating places types for goodle auto locations
    switch (typeOfTransport) {
      case TRANSPORTATION_TYPES.FLIGHT: {
        this.placesType = ["airport"];

        break;
      }
      case TRANSPORTATION_TYPES.TRAIN: {
        this.placesType = ["train_station"]
        break;
      }
      case TRANSPORTATION_TYPES.BUS: {
        this.placesType = ["bus_station"]
        break;
      }
      case TRANSPORTATION_TYPES.CAR: {
        this.placesType = []
        break;
      }
      default: {
        this.placesType = []
        break;
      }
    }
  }

  updateValidationOfCost(group: FormGroup) {
    group.get('costPerAdult')?.setValidators(Validators.required);
    if (this.noOfChildren) {
      if (this.childrenAboveTwo) {
        group.get('costPerChild')?.setValidators(Validators.required);
      } else {
        group.get('costPerChild')?.setValue('');
        group.get('costPerChild')?.setValidators([]);
        group.get('costPerChild')?.disable();
      }
      if (this.childrenBelowTwo) {
        group.get('costPerInfant')?.setValidators(Validators.required);
      } else {
        group.get('costPerInfant')?.setValue('');
        group.get('costPerInfant')?.setValidators([]);
        group.get('costPerInfant')?.disable();
      }

    } else {
      group.get('costPerChild')?.setValue('');
      group.get('costPerChild')?.setValidators([]);
      group.get('costPerChild')?.disable();
      group.get('costPerInfant')?.setValue('');
      group.get('costPerInfant')?.setValidators([]);
      group.get('costPerInfant')?.disable();
    }
    group.get('totalCost')?.setValidators(Validators.required);

    group.get('costPerAdult')?.updateValueAndValidity();
    group.get('costPerChild')?.updateValueAndValidity();
    group.get('costPerInfant')?.updateValueAndValidity();
    group.get('totalCost')?.updateValueAndValidity();
  }

  calculateTotalCost(group: FormGroup) {
    const costPerAdult = group.get('costPerAdult')?.value || 0;
    const costPerChild = group.get('costPerChild')?.value || 0;
    const costPerInfant = group.get('costPerInfant')?.value || 0;
    const totalCost = (costPerAdult * this.noOfAdults) + (costPerChild * this.childrenAboveTwo) + (costPerInfant * this.childrenBelowTwo);
    group.patchValue({ totalCost: totalCost });
  }

  transportations(): FormArray {
    return this.transportationForm.get('transportations') as FormArray;
  }

  addTransportation() {
    if (this.transportationForm.valid) {
      this.transportations().push(this.createTransportationGroup());
    } else {
      this.transportationForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form is invalid, please fill all required fields!");
    }
  }

  removeTransportation(index: number) {
    this.transportations().removeAt(index);
    this.transportationForm.markAsDirty();
  }

  patchTransportationForm(storedFormData: any) {
    const transportationsArray = this.transportations();
    storedFormData.forEach((transportation: any, index: number) => {
      if (transportationsArray.length <= index) {
        transportationsArray.push(this.createTransportationGroup());
      }
      transportationsArray.at(index).patchValue({
        ...transportation,
        imageDoc: transportation.imagePath,
        imagePath: transportation.imagePath,
        departureDate: transportation.departureTime ? this.convertToDate(transportation.departureTime) : null,
        departureTime: transportation.departureTime ? this.convertToDate(transportation.departureTime) : null,
        arrivalDate: transportation.arrivalTime ? this.convertToDate(transportation.arrivalTime) : null,
        arrivalTime: transportation.arrivalTime ? this.convertToDate(transportation.arrivalTime) : null
      });
    });
  }

  createExistingTransportsList() {
    let transportList: any[] = [];
    if (this.showOnlyCarTransport) {
      // Add typeOfTransport for cars
      if (this.storedCarsData && this.storedCarsData.data) {
        this.storedCarsData.data = this.storedCarsData.data.map((car: any) => ({
          ...car,
          typeOfTransport: TRANSPORTATION_TYPES.CAR
        }));
        transportList = [...transportList, ...this.storedCarsData.data];
        this.transportationForm.get('carSectionNote')?.patchValue(this.storedCarsData?.note);
      }
    } else {
      // Add typeOfTransport for flights
      if (this.storedFlightsData && this.storedFlightsData.data) {
        this.storedFlightsData.data = this.storedFlightsData.data.map((flight: any) => ({
          ...flight,
          typeOfTransport: TRANSPORTATION_TYPES.FLIGHT
        }));
        transportList = [...transportList, ...this.storedFlightsData.data];
        this.transportationForm.get('flightSectionNote')?.patchValue(this.storedFlightsData?.note);
      }

      // Add typeOfTransport for trains
      if (this.storedTrainsData && this.storedTrainsData.data) {
        this.storedTrainsData.data = this.storedTrainsData.data.map((train: any) => ({
          ...train,
          typeOfTransport: TRANSPORTATION_TYPES.TRAIN
        }));
        transportList = [...transportList, ...this.storedTrainsData.data];
        this.transportationForm.get('trainSectionNote')?.patchValue(this.storedTrainsData?.note);
      }

      // Add typeOfTransport for buses
      if (this.storedBusesData && this.storedBusesData.data) {
        this.storedBusesData.data = this.storedBusesData.data.map((bus: any) => ({
          ...bus,
          typeOfTransport: TRANSPORTATION_TYPES.BUS
        }));
        transportList = [...transportList, ...this.storedBusesData.data];
        this.transportationForm.get('busSectionNote')?.patchValue(this.storedBusesData?.note);
      }

      // Add typeOfTransport for cars
      if (this.storedCarsData && this.storedCarsData.data) {
        this.storedCarsData.data = this.storedCarsData.data.map((car: any) => ({
          ...car,
          typeOfTransport: TRANSPORTATION_TYPES.CAR
        }));
        transportList = [...transportList, ...this.storedCarsData.data];
        this.transportationForm.get('carSectionNote')?.patchValue(this.storedCarsData?.note);
      }

      // Add typeOfTransport for Ferry
      if (this.storedFerryData && this.storedFerryData.data) {
        this.storedFerryData.data = this.storedFerryData.data.map((ferry: any) => ({
          ...ferry,
          typeOfTransport: TRANSPORTATION_TYPES.FERRY
        }));
        transportList = [...transportList, ...this.storedFerryData.data];
        this.transportationForm.get('ferrySectionNote')?.patchValue(this.storedFerryData?.note);
      }

      // Add typeOfTransport for Cruise
      if (this.storedCruiseData && this.storedCruiseData.data) {
        this.storedCruiseData.data = this.storedCruiseData.data.map((cruise: any) => ({
          ...cruise,
          typeOfTransport: TRANSPORTATION_TYPES.CRUISE
        }));
        transportList = [...transportList, ...this.storedCruiseData.data];
        this.transportationForm.get('cruiseSectionNote')?.patchValue(this.storedCruiseData?.note);
      }
    }
    return transportList;
  }

  onFileSelected(event: any, index: any) {
    const file = event.target.files[0];
    if (file.size > 5 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
      return;
    }
    if (file) {
      const formData = new FormData();
      formData.append('image', file);
      let type = this.transportations().at(index)?.get("typeOfTransport")?.value;
      switch (type) {
        case TRANSPORTATION_TYPES.FLIGHT:
          type = "flights";
          break;
        case TRANSPORTATION_TYPES.TRAIN:
          type = "trains";
          break;
        case TRANSPORTATION_TYPES.BUS:
          type = "buses";
          break;
        case TRANSPORTATION_TYPES.CAR:
          type = "cars";
          break;
        case TRANSPORTATION_TYPES.FERRY:
          type = "ferries";
          break;
        case TRANSPORTATION_TYPES.CRUISE:
          type = "cruises";
          break;
        default:
          console.warn(`Unknown transportation type: ${type}`);
      }
      this._lovDataService.uploadImage(formData, type).subscribe({
        next: (res) => {
          this.transportations().at(index).get('imageDoc')?.setValue(file);
          this.transportations().at(index).get('imagePath')?.setValue(res);
          this.transportationForm.markAsDirty();
          this.transportationForm.markAsTouched();
        },
        error: (error) => {
          console.error('Error uploading image: ', error);
          this._responseNotificationService.showMessage("Error uploading image", true);
        }
      });
    }
  }

  deleteImage(controlName: string, index: any) {
    this.transportations().at(index).get(controlName)?.setValue(null);
    this.transportations().at(index).get(controlName)?.clearValidators();
    this.transportations().at(index).get(controlName)?.updateValueAndValidity();
  }

  getImgUrl(file: any) {
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      return fileURL;
    } else {
      return file;
    }
  }

  checkTransportationTypePresent(typeOfTransport: string): boolean {
    for (let i = 0; i < this.transportations().length; i++) {
      const transportation = this.transportations().at(i).value;
      if (transportation?.typeOfTransport === typeOfTransport) {
        return true;
      }
    }
    return false;
  }

  checkTransportationTypeExists(transportGroup: any, transportationTypes: string[]): boolean {
    let selectedType = transportGroup.get("typeOfTransport")?.value;
    if (selectedType && transportationTypes.includes(selectedType)) {
      return true;
    }
    return false;
  }

  onCurrencyChange(event:any){
    const value = event.target.value;
    this.selectedCurrency = value;
    this.emitCurrencyChange.emit(value);
  }

  async onSubmit(): Promise<boolean> {
    if (!this.transportationForm.valid) {
      this.handleInvalidForm();
      return false;
    }

    try {

      const formData = await this.serializeFormData(this.transportationForm.getRawValue());

      let flightData: any;
      let trainData: any;
      let busData: any;
      let carData: any;
      let ferryData: any;
      let cruiseData: any;

      if (this.showOnlyCarTransport) {
        flightData = this.storedFlightsData;
        trainData = this.storedTrainsData;
        busData = this.storedBusesData;
        ferryData = this.storedFerryData;
        cruiseData = this.storedCruiseData;
      } else {
        flightData = this.prepareFlightData(formData);
        trainData = this.prepareTrainData(formData);
        busData = this.prepareBusData(formData);
        ferryData = this.prepareFerryData(formData);
        cruiseData = this.prepareCruiseData(formData);
      }
      carData = this.prepareCarData(formData);

      if (this.editQuote) {
        await this.handleEditQuote(flightData, trainData, busData, carData, ferryData, cruiseData);
      } else {
        await this.handleNewQuote(flightData, trainData, busData, carData, ferryData, cruiseData);
      }

      this.transportationForm.markAsPristine();
      return true;
    } catch (error) {
      console.error("Error during form submission", error);
      return false;
    }
  }

  private handleInvalidForm(): void {
    this.transportationForm.markAllAsTouched();
    this._globalService.scrollToFirstInvalidControl();
    this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
  }

  private prepareFlightData(formData: any): any {
    return {
      ...formData,
      data: formData.transportations.filter((t: any) => t.typeOfTransport === TRANSPORTATION_TYPES.FLIGHT),
      type: TRANSPORTATION_TYPES.FLIGHT,
      id: this.storedFlightsData?.id || null,
      organizationId: this.storedFlightsData?.organizationId || null,
      note: formData.flightSectionNote,
    };
  }

  private prepareTrainData(formData: any): any {
    return {
      ...formData,
      data: formData.transportations.filter((t: any) => t.typeOfTransport === TRANSPORTATION_TYPES.TRAIN),
      type: TRANSPORTATION_TYPES.TRAIN,
      id: this.storedTrainsData?.id || null,
      organizationId: this.storedTrainsData?.organizationId || null,
      note: formData.trainSectionNote,
    };
  }

  private prepareBusData(formData: any): any {
    return {
      ...formData,
      data: formData.transportations.filter((t: any) => t.typeOfTransport === TRANSPORTATION_TYPES.BUS),
      type: TRANSPORTATION_TYPES.BUS,
      id: this.storedBusesData?.id || null,
      organizationId: this.storedBusesData?.organizationId || null,
      note: formData.busSectionNote,
    };
  }

  private prepareCarData(formData: any): any {
    return {
      ...formData,
      data: formData.transportations.filter((t: any) => t.typeOfTransport === TRANSPORTATION_TYPES.CAR),
      type: TRANSPORTATION_TYPES.CAR,
      id: this.storedCarsData?.id || null,
      organizationId: this.storedCarsData?.organizationId || null,
      note: formData.carSectionNote,
    };
  }

  private prepareFerryData(formData: any): any {
    return {
      ...formData,
      data: formData.transportations.filter((t: any) => t.typeOfTransport === TRANSPORTATION_TYPES.FERRY),
      type: TRANSPORTATION_TYPES.FERRY,
      id: this.storedFerryData?.id || null,
      organizationId: this.storedFerryData?.organizationId || null,
      note: formData.ferrySectionNote,
    };
  }

  private prepareCruiseData(formData: any): any {
    return {
      ...formData,
      data: formData.transportations.filter((t: any) => t.typeOfTransport === TRANSPORTATION_TYPES.CRUISE),
      type: TRANSPORTATION_TYPES.CRUISE,
      id: this.storedCruiseData?.id || null,
      organizationId: this.storedCruiseData?.organizationId || null,
      note: formData.cruiseSectionNote,
    };
  }

  private async handleEditQuote(flightData: any, trainData: any, busData: any, carData: any, ferryData: any, cruiseData: any): Promise<void> {
    if (flightData) {
      if(flightData.data?.length == 0){
        this.emitFlightsRemoved.emit();
      }
      this.emitWithoutApi(flightData, TRANSPORTATION_TYPES.FLIGHT)
    }
    if (trainData) {
      this.emitWithoutApi(trainData, TRANSPORTATION_TYPES.TRAIN);
    }
    if (busData) {
      this.emitWithoutApi(busData, TRANSPORTATION_TYPES.BUS);
    }
    if (carData) {
      this.emitWithoutApi(carData, TRANSPORTATION_TYPES.CAR);
    }
    if (ferryData) {
      this.emitWithoutApi(ferryData, TRANSPORTATION_TYPES.FERRY);
    }
    if (cruiseData) {
      this.emitWithoutApi(cruiseData, TRANSPORTATION_TYPES.CRUISE);
    }
    this.updateQuote.emit();
  }

  private async handleNewQuote(flightData: any, trainData: any, busData: any, carData: any, ferryData: any, cruiseData: any): Promise<void> {
    const apiCalls: Observable<any>[] = [];
    const responseHandlers: ((response: any) => void)[] = [];

    if (flightData) {
      apiCalls.push(this._itineraryService.addTransportationFlights(flightData));
      responseHandlers.push((response) => this.handleApiResponse(response, TRANSPORTATION_TYPES.FLIGHT));
    }
    if (trainData) {
      apiCalls.push(this._itineraryService.addTrainTransportationDetails(trainData));
      responseHandlers.push((response) => this.handleApiResponse(response, TRANSPORTATION_TYPES.TRAIN));
    }
    if (busData) {
      apiCalls.push(this._itineraryService.addBusTransportationDetails(busData));
      responseHandlers.push((response) => this.handleApiResponse(response, TRANSPORTATION_TYPES.BUS));
    }
    if (carData) {
      apiCalls.push(this._itineraryService.addCarTransportationDetails(carData));
      responseHandlers.push((response) => this.handleApiResponse(response, TRANSPORTATION_TYPES.CAR));
    }
    if (ferryData) {
      apiCalls.push(this._itineraryService.addFerryTransportationDetails(ferryData));
      responseHandlers.push((response) => this.handleApiResponse(response, TRANSPORTATION_TYPES.FERRY));
    }
    if (cruiseData) {
      apiCalls.push(this._itineraryService.addCruiseTransportationDetails(cruiseData));
      responseHandlers.push((response) => this.handleApiResponse(response, TRANSPORTATION_TYPES.CRUISE));
    }

    if (apiCalls.length > 0) {
      const responses = await lastValueFrom(forkJoin(apiCalls));
      responses.forEach((response, index) => responseHandlers[index](response));
      this._responseNotificationService.showMessage("Transportation Added!");
    }
  }

  private emitWithoutApi(data: any, type: string): void {
    switch (type) {
      case TRANSPORTATION_TYPES.FLIGHT:
        this.storeFlightsFormData.emit(data);
        break;
      case TRANSPORTATION_TYPES.TRAIN:
        this.storeTrainsFormData.emit(data);
        break;
      case TRANSPORTATION_TYPES.BUS:
        this.storeBusesFormData.emit(data);
        break;
      case TRANSPORTATION_TYPES.CAR:
        this.storeCarsFormData.emit(data);
        break;
      case TRANSPORTATION_TYPES.FERRY:
        this.storeFerryFormData.emit(data);
        break;
      case TRANSPORTATION_TYPES.CRUISE:
        this.storeCruiseFormData.emit(data);
        break;
      default:
        console.warn(`Unknown transportation type: ${type}`);
    }
  }

  private handleApiResponse(response: any, type: string): void {
    response.dataSaved = true;
    switch (type) {
      case TRANSPORTATION_TYPES.FLIGHT:
        this.storeFlightsFormData.emit(response);
        break;
      case TRANSPORTATION_TYPES.TRAIN:
        this.storeTrainsFormData.emit(response);
        break;
      case TRANSPORTATION_TYPES.BUS:
        this.storeBusesFormData.emit(response);
        break;
      case TRANSPORTATION_TYPES.CAR:
        this.storeCarsFormData.emit(response);
        break;
      case TRANSPORTATION_TYPES.FERRY:
        this.storeFerryFormData.emit(response);
        break;
      case TRANSPORTATION_TYPES.CRUISE:
        this.storeCruiseFormData.emit(response);
        break;
      default:
        console.warn(`Unknown transportation type: ${type}`);
    }
  }

  private async serializeFormData(formData: any) {
    const serializeData = {
      itineraryId: this.itineraryId,
      leadId: this.leadId,
      transportations: formData.transportations.map((transportation: any) => ({
        ...transportation,
        departureTime: transportation.departureDate ? this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(transportation.departureDate), this.convertToDate(transportation.departureTime))) : null,
        arrivalTime: transportation.arrivalDate ? this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(transportation.arrivalDate), this.convertToDate(transportation.arrivalTime))) : null,
      })),
      flightSectionNote: formData.flightSectionNote,
      trainSectionNote: formData.trainSectionNote,
      busSectionNote: formData.busSectionNote,
      carSectionNote: formData.carSectionNote,
      ferrySectionNote: formData.ferrySectionNote,
      cruiseSectionNote: formData.cruiseSectionNote,
    };
    return serializeData;
  }

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.transportationForm.dirty || this.transportationForm.invalid) && this.transportationForm.touched;
  }

  gettingPopulatedHotelvalues(event: any, i: any) {
    (this.transportationForm.get('transportations') as FormArray).at(i).patchValue({
      typeOfCar: event?.transferDetails?.vehicleDetails[0]?.vehicleType,
      vehicleSelection: event?.transferDetails?.vehicleDetails[0]?.vehicleName,
      numberOfSeats: event?.transferDetails?.vehicleDetails[0]?.numberOfSeats,
      transferMode: event?.transferDetails?.vehicleDetails[0]?.transferMode
    })
  }

  // Flight API search
  async openSearchFlights(transportGroup:any, index:any){
     const modal = await this._modalController.create({
      component: FlightSearchComponent,
      backdropDismiss: true,
      cssClass: 'my-modal-large-component-css',
      componentProps: {
        transportGroup: transportGroup,
        tripDetails: this.itineraryDetails,
        onFlightSelected: (data: any) => this.onRealFlighSelection(data, transportGroup)
      }
    });

    return await modal.present();
  }

  onRealFlighSelection(flights: any[], transportGroup: FormGroup) {
    if (!transportGroup.get('departure')?.value) {
      var firstFlight = flights.shift();
      const destinationLabel = `${firstFlight.Destination?.AirportName || ''}, ${firstFlight.Destination?.CityName || ''}, ${firstFlight.Destination?.CountryName || ''}`.trim();
      const originLabel = `${firstFlight.Origin?.AirportName || ''}, ${firstFlight.Origin?.CityName || ''}, ${firstFlight.Origin?.CountryName || ''}`.trim();
      const transportName = `${firstFlight.AirlineName} | ${firstFlight.AirlineCode} ${firstFlight.FlightNumber}`.trim();

      transportGroup.patchValue({
        selectedType: 'FreeText',
        transportationName: transportName || '',
        departure: originLabel,
        arrival: destinationLabel,
        departureDate: this.getFlightDate(firstFlight.DepTime),
        departureTime: this.getFlightTime(firstFlight.DepTime),
        arrivalDate: this.getFlightDate(firstFlight.ArrTime),
        arrivalTime: this.getFlightTime(firstFlight.ArrTime),
      });
      this.transportationForm.markAsDirty();
      this.transportationForm.markAsTouched();
    }

    flights.forEach(flight => {
      const destinationLabel = `${flight.Destination?.AirportName || ''}, ${flight.Destination?.CityName || ''}, ${flight.Destination?.CountryName || ''}`.trim();
      const originLabel = `${flight.Origin?.AirportName || ''}, ${flight.Origin?.CityName || ''}, ${flight.Origin?.CountryName || ''}`.trim();
      const transportName = `${flight.AirlineName} | ${flight.AirlineCode} ${flight.FlightNumber}`.trim();

      var newTransportGroup = this.createTransportationGroup()
      newTransportGroup.patchValue({
        typeOfTransport: TRANSPORTATION_TYPES.FLIGHT,
        selectedType: 'FreeText',
        transportationName: transportName || '',
        departure: originLabel,
        arrival: destinationLabel,
        departureDate: this.getFlightDate(flight.DepTime),
        departureTime: this.getFlightTime(flight.DepTime),
        arrivalDate: this.getFlightDate(flight.ArrTime),
        arrivalTime: this.getFlightTime(flight.ArrTime),
      });

      this.transportations().push(newTransportGroup);
      this.transportationForm.markAsDirty();
      this.transportationForm.markAsTouched();
    });

  }

  getFlightDate(date:any): Date {
    if (!date) {
      return new Date(NaN);
    }

    const dateString = typeof date === 'string' ? date : date.toISOString?.();
    if (!dateString) {
      return new Date(NaN);
    }

    const parts = dateString.split('T');
    return new Date(parts[0] || dateString);
  }

  getFlightTime(date:any): Date {
    if (!date) {
      return new Date(NaN);
    }

    const dateString = typeof date === 'string' ? date : date.toISOString?.();
    if (!dateString) {
      return new Date(NaN);
    }

    const parts = dateString.split('T');
    const timePart = parts[1] || '';
    if (!timePart) {
      return new Date(dateString);
    }

    const [hours = '0', minutes = '0'] = timePart.split(':');
    const parsedDate = new Date(parts[0] || dateString);
    parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
    return parsedDate;
  }
}
